import { render, staticRenderFns } from "./ReportTemplate3Item.vue?vue&type=template&id=642138f8&"
import script from "./ReportTemplate3Item.vue?vue&type=script&lang=js&"
export * from "./ReportTemplate3Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports